// ResponsiveContainer.jsx - 段階的レスポンシブ改善用コンポーネント

import React from 'react';
import PropTypes from 'prop-types';

/**
 * レスポンシブコンテナコンポーネント
 * 既存のmax-w-4xlを段階的に改善するためのラッパー
 */
const ResponsiveContainer = ({ 
  children, 
  className = '',
  variant = 'quiz',  // 'quiz' | 'modal' | 'standard'
  enableResponsive = true  // 段階的移行用フラグ
}) => {
  // 現在は既存スタイルを保持しつつ、将来的な改善の基盤を提供
  const getContainerClasses = () => {
    const baseClasses = 'w-full mx-auto';
    
    if (!enableResponsive) {
      // 既存の動作を完全に保持
      return `max-w-4xl ${baseClasses}`;
    }
    
    // レスポンシブ改善版（段階的適用）
    switch (variant) {
      case 'quiz':
        return `max-w-4xl lg:max-w-5xl xl:max-w-6xl ${baseClasses} px-2 sm:px-4 md:px-6`;
      case 'modal':
        return `max-w-3xl lg:max-w-4xl ${baseClasses} px-2 sm:px-4 md:px-6`;
      case 'standard':
        return `max-w-4xl ${baseClasses} px-2 sm:px-4 md:px-6`;
      default:
        return `max-w-4xl ${baseClasses}`;
    }
  };

  return (
    <div className={`${getContainerClasses()} ${className}`}>
      {children}
    </div>
  );
};

ResponsiveContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['quiz', 'modal', 'standard']),
  enableResponsive: PropTypes.bool
};

export default ResponsiveContainer; 